module.exports = __webpack_public_path__ + "src/img/sigfloLogoTempDark.ed2d95cc.png";